import { TFunction } from "i18next";
import * as Yup from "yup";

import { DeactivateParticipantFormType } from "./hooks/useParticipantDeactivate";

type DeactivateParticipantValidationType = {
  [Property in keyof DeactivateParticipantFormType]?: Yup.AnySchema;
};

export function deactivateParticipantValidationSchema(t: TFunction) {
  return Yup.object().shape<DeactivateParticipantValidationType>({
    reason: Yup.string().trim().required(t("proceedingParticipants.deactivate.reasonRequired")),
  });
}
